var map = {
	"./binance.png": 7828,
	"./bitget.png": 483,
	"./bitmart.png": 595,
	"./bybit.png": 2410,
	"./digifinex.png": 4193,
	"./gate.io.png": 3407,
	"./huobi.png": 5045,
	"./kucoin.png": 1083,
	"./mexc.png": 3529
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4227;